"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("./utils");
function validatorBradesco(bankBranch, bankAccount) {
  var _ref = (0, utils_1.cleanAccountAndBranchStrings)(bankAccount, bankBranch),
    formattedAccount = _ref.formattedAccount;
  var _ref2 = (0, utils_1.getAccountAndDigit)(formattedAccount),
    account = _ref2.account,
    accountDigit = _ref2.accountDigit;
  var isAccountValid = validateAccount(account, accountDigit);
  return isAccountValid;
}
exports.default = validatorBradesco;
function validateAccount(account, accountDigit) {
  var multipliers = ['3', '2', '7', '6', '5', '4', '3', '2'];
  var paddedAccount = (0, utils_1.leftPad)(account, '0', multipliers.length);
  var result = (0, utils_1.getMultipliersAndAccountProduct)(multipliers, paddedAccount);
  var dv;
  var divRest = result % 11;
  switch (divRest) {
    case 0:
      dv = '0';
      break;
    case 1:
      dv = 'P';
      break;
    default:
      dv = 11 - divRest;
  }
  return dv.toString() === accountDigit;
}
function validadeBranch(branch, branchDigit) {
  var multipliers = ['5', '4', '3', '2'];
  var paddedBranch = (0, utils_1.leftPad)(branch, '0', multipliers.length);
  var result = (0, utils_1.getMultipliersAndAccountProduct)(multipliers, paddedBranch);
  if (result === 10) {
    return branchDigit.toUpperCase() === 'P';
  }
  var divRest = result % 11;
  var numberDigit = Number(branchDigit);
  if (divRest == 0) {
    return numberDigit === divRest;
  }
  var dv = 11 - divRest;
  return dv === numberDigit;
}